require('./bootstrap');
import {Modal} from './Modal';
import Echo from "laravel-echo"

// import { Chart, registerables } from 'chart.js';
// Chart.register(...registerables);
// window.Chart = Chart;

window.Pusher = require('pusher-js');

$(function() {
    $(document).on('select2:open', () => {
        document.querySelector('.select2-search__field').focus();
    });
});

window.Modal = Modal;

window.routes = {};

$(function() {

    let path = location.pathname,
        key = 'collapse_'+path,
        options;

    try {
        options = JSON.parse(localStorage.getItem(key) || '{}')
    } catch(e) {
        options = {};
    }

    $('body')
        .on(
            'click',
            'button[data-action]',
            e => {
                e.preventDefault();

                let button = $(e.currentTarget),
                    action = button.attr('data-action'),
                    formData = JSON.parse(button.attr('data-post-data') || '{}') || {},
                    modal = new Modal('actionModal', button.attr('data-title'));

                if(!button.hasClass('no-loader'))
                    button.prepend('<span class="loader pr-2"><span class="spinner-border spinner-border-sm"></span></span>').attr('disabled', true);

                axios.post(action, formData).then(response => modal.defaultResponse(response)).catch(error => modal.manageErrors(error)).then(() => {
                    button.removeAttr('disabled').find('.loader').remove();
                })

                modal.generate().$modal.on('hidden.bs.modal', () => {
                    modal.destroy();
                });
            }
        )
        .on(
            'click',
            '[data-modal-url]',
            e => {
                e.preventDefault();
                e.stopPropagation();

                let button = $(e.currentTarget),
                    title = button.data('modalTitle') || '',
                    url = button.attr('data-modal-url'),
                    classes = button.data('modalClasses'),
                    options = button.data('modalOptions') || {backdrop: true},
                    modal;

                if(!button.hasClass('no-loader'))
                    button.prepend('<span class="loader pr-2"><span class="spinner-border spinner-border-sm"></span></span>').attr('disabled', true);

                modal = new Modal('id', title);
                modal.generate().setOptions(options).displayLoading().$modal.on('hidden.bs.modal', () => {
                    modal.destroy();
                });

                if(classes)
                    modal.$modal.find('.modal-dialog').addClass(classes);

                axios.get(url)
                    .then(response => modal.defaultResponse(response))
                    .catch(error => modal.manageErrors(error))
                    .then(() => {
                        button.removeAttr('disabled').find('.loader').remove();
                    })


            }

        )

        .on('click', '[data-toggle=collapse]', e => {

            let target = $(e.currentTarget).attr('data-target');

            options[target] = $(e.currentTarget).hasClass('collapsed');

            localStorage.setItem(key, JSON.stringify(options));

        })

        .on('click', 'a[data-section]', function(e) {

            e.preventDefault();

            let target = ($(this).attr('data-section')),
                $target = $(target);

            $target.toggleClass('show');
            $(this).toggleClass('collapsed btn-success btn-danger').find('i').toggleClass('fa-chevron-down fa-chevron-up');


            let $opened = $('a[data-section].collapsed:not([data-section="' + target + '"])');

            // if ($opened.length) {
            //     $opened.removeClass('collapsed').find('i').addClass('fa-chevron-down').removeClass(' fa-chevron-up');
            // }

            //$('body .collapse:not(' + $(this).attr('data-section') + ')').removeClass('show');


        })

        .on('change', 'input.uppercase', function() {
            $(this).val( $(this).val().toUpperCase());
        })

        .off('change', 'input.currency')
        .on('change', 'input.currency', function() {

            let value = parseFloat($(this).val());
            if (isNaN(value)) value = 0;

            $(this).val(value.toFixed(2));

        });

    $('input.currency').change();
    $('input.uppsercase').change();

    Object.keys(options).forEach(selector => {

        if(!options[selector]) {
            $('[data-toggle=collapse][data-target="'+selector+'"]').addClass('collapsed');
            $(selector).removeClass('show');
        }

    })

    document.querySelectorAll('input[type=text].uppercase').forEach(input => {
        input.addEventListener('input', (e) => {
            e.currentTarget.value = e.currentTarget.value.toUpperCase();
        })
    })

});

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_PUSHER_APP_KEY,
    cluster: process.env.MIX_PUSHER_APP_CLUSTER,
    wsHost: null,
    wsPort: 6001,
    forceTLS: true,
    disableStats: true,
});

window.$notifications = new Vue({
    el: '#notifications',
    data: {
        alerts: [],
        notifications: [],
        notification_opened: false,
        user: null
    },
    methods: {

        getNotifications() {
            axios.get('/api/user').then(response => {

                this.$set(this, 'user', response.data);
                this.$set(this, 'notifications', response.data.unread_notifications);

                if(this.notifications.length)
                    this.showNotification(this.notifications[0]);

            });
        },
        formatNotificationDate(created_at) {
            moment.locale('it');
            const notificationDate = moment(created_at);
            const now = moment();
            if (now.diff(notificationDate, 'days') < 1) {
                return notificationDate.fromNow();
            } else {
                return notificationDate.format('DD/MM/YYYY');
            }
        },

        markAsRead(notification) {

            axios.post(`/notification/${notification.id}/mark-as-read`)
                .then(({data}) => {
                    this.$set(this, 'notifications', data);
                    if(this.notifications.length)
                        this.showNotification(this.notifications[0]);
                })

        },

        showAlert(alert) {

            let modal = new Modal('alert', 'Attenzione', null, {backdrop: 'static', keyboard: false});

            modal.generate().$modal.find('.modal-dialog').addClass('.modal-lg');
            modal.setTitle(alert.title);
            modal.setBody(alert.message);
            modal.display();

        },

        showNotification(notification) {

            if(this.notification_opened)
                return;

            this.notification_opened = true;

            let modal = new Modal('notification', 'Attenzione', null, {backdrop: 'static', keyboard: false});

             modal.generate().$modal.find('.modal-dialog').addClass('.modal-lg');
             modal.setTitle(notification.data.title);

             axios.get('/notification/' + notification.id).then(response => modal.defaultResponse(response))
                 .catch(error => modal.manageErrors(error))
                 .then(() => {
                     if(notification.data.actions !== undefined) {

                         notification.data.actions.forEach(action => {

                             modal.$modal.find('.modal-footer')
                                 .append(`<a href="${action.url}" class="${action.class}">${action.title}</a>`);
                         })


                     }
                 })



             //modal.setBody("<pre class='pre'>" + JSON.stringify(notification) +"</pre>");
             //modal.$modal.find('.modal-footer').append('<a href="/alerts" class="btn btn-primary">Rispondi</a> <a href="/alerts" class="btn btn-danger">Posponi</a>');
             //modal.display();

             modal.$modal.on('hidden.bs.modal', () => {
                 modal.destroy();
                 this.notification_opened = false;
                 this.markAsRead(notification);
             });

        }

    },
    mounted() {

        axios.get('/api/user').then(response => {

            this.$set(this, 'user', response.data);
            this.$set(this, 'notifications', response.data.unread_notifications);

            window.Echo.private('App.Models.User.' + this.user.id)
                .notification((notification) => {
                    this.getNotifications();
                }).listen("AlertCreated", e => {
                    this.alerts.push(e);
            })
        });


    }
})
